import { GetStaticPaths, GetStaticProps } from "next";
import { Home } from "@/routes/Unauth/Home";
import { HomeContent, SUPPORTED_LOCALES, Locale } from "@/constants/landingPages";

interface LocaleHomePageProps {
  content: HomeContent;
  locale: Locale;
}

export default function LocaleHomePage({ content, locale }: LocaleHomePageProps) {
  return <Home content={content} locale={locale} />;
}

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = SUPPORTED_LOCALES.map((locale) => ({
    params: { locale },
  }));

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps<LocaleHomePageProps> = async ({ params }) => {
  const locale = params?.locale as Locale;

  try {
    // Dynamicky načítame content pre daný locale
    const content = await import(`@/content/home/${locale}.json`);

    return {
      props: {
        content: content.default as HomeContent,
        locale,
      },
    };
  } catch (error) {
    // Ak content pre locale neexistuje, fallback na slovenčinu
    const content = await import(`@/content/home/sk.json`);

    return {
      props: {
        content: content.default as HomeContent,
        locale,
      },
    };
  }
};
